import { getGameSize } from '../../../Config/Levels';
import { getMilestoneReward } from '../../../Config/Missions';
import { gameConfig } from '../../../index';
import { Popup } from '../../../Managers/Popups';
import { IDailyMission, IStateMissions } from '../../../State/reducers/missions';
import { ICollectablesData } from '../../../State/reducers/player';
import { Collection } from '../../../Tiles/TileSet';
import HudView from '../../../View/HudView';
import { UIButton } from '../../Shared/Buttons/UIButton';
import { MapHubPopup } from '../../Shared/MapHubPopup';
import { SocialRewardBox } from '../Social/SocialRewardBox';
import { CollectablesPage } from './Collectables/CollectablesPage';
import { DailyMissions } from './DailyMissions/DailyMissions';
import { storeRewards } from '../../../State/reducers/score';
import { TGameAreas, TransactionActionTypes } from '../../../DeltaTracking/ResourceParamBuilder';
import ResourceTracking from '../../../Managers/Tracking/ResourceTracking';

/**
 * journal popup
 * shows an popup that fills the whole screen
 * missions, events and activeCollection
 */

// const logger: ILogger = getLogger('[JOURNALPOPUP]:');

export class JournalPopup extends MapHubPopup {
    public curMissionCount: number;
    public missionsData: IDailyMission[];
    public missionsPage: DailyMissions;
    public curMilestone: number;
    private collectablesProgress: ICollectablesData;
    private selectedCollectable: Collection;

    constructor(
        hudView: HudView,
        curMissionCount: number,
        missions: IDailyMission[],
        curMilestone: number,
        collectablesProgress: ICollectablesData,
        selectedCollectable: Collection
    ) {
        super(
            'ScrapBook',
            hudView,
            gameConfig.game_width * 0.915,
            gameConfig.game_height * 0.65,
            getGameSize().gameHeight * 0.65,
            Popup.JOURNAL
        );

        this.curMissionCount = curMissionCount;
        this.curMilestone = curMilestone;
        this.missionsData = missions;
        this.hudView = hudView;
        this.collectablesProgress = collectablesProgress;
        this.selectedCollectable = selectedCollectable;
        this.alpha = 0;

        const missionsTab = this.addTab('DailyGoals');
        missionsTab.alpha = 0;

        const collectionsTab = this.addTab('Collectables');
        collectionsTab.alpha = 0;

        const eventsTab = this.addTab('comingsoon');
        eventsTab.interactive = eventsTab.buttonMode = false;
        eventsTab.alpha = 0;

        this.createJournalPages();
    }

    public async giveReward(): Promise<void> {
        // this event will have to be sent before the reward is actually given
        const rewards = getMilestoneReward(3);
        storeRewards([rewards], TransactionActionTypes.DAILY_MISSION);
        [rewards].forEach(r => {
            ResourceTracking.sendRewardResourceEvent(
                r.id,
                r.val as number,
                TransactionActionTypes.DAILY_MISSION,
                TGameAreas.MAP
            );
        });

        return super.giveReward(new SocialRewardBox([rewards], 'daily'));
    }

    public update(missions: IStateMissions) {
        this.curMissionCount = missions.completedCount;

        if (this.curActiveTab === 0 && this.missionsPage) {
            this.missionsPage.update(missions);
        }
    }

    protected async tweenOutReward(button: UIButton, reward: SocialRewardBox) {
        return super.tweenOutReward(button, reward);
    }

    private createMissionsPage() {
        const missions = new DailyMissions(
            this.bgTab.width,
            this.bgTab.height,
            this.missionsData,
            this.curMissionCount,
            this.giveReward.bind(this),
            this.curMilestone
        );

        this.addPage(missions);

        this.missionsPage = missions;
    }

    private createCollectablesPage() {
        const collectablesPage = new CollectablesPage(
            this.bgTab,
            this.collectablesProgress,
            this.selectedCollectable
        );
        this.addPage(collectablesPage);
    }

    private createJournalPages() {
        this.createMissionsPage();
        this.createCollectablesPage();
    }
}
